import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import socketIO from "./socket.io";

ReactDOM.render(
  <Router>
    <App socket={socketIO()} />
  </Router>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx